<template>
  <div class="container-fluid">
    <div v-if="rating" class="modal-backdrop fade show"></div>
    <modal-rating v-if="rating" :data="data" :show="rating" @onClear="onClear"></modal-rating>
    <div class="card bg-light-info shadow-none position-relative overflow-hidden">
      <div class="card-body px-4 py-3">
        <div class="row align-items-center">
          <div class="col-9">
            <h4 class="fw-semibold mb-8">Reservar una cita</h4>
            <p class="card-subtitle mb-3">
              Completa el formulario para reservar tu cita
              <br>
              <b>Horarios de Atención de Lunes a Viernes de 9:00 AM a 5:00 PM</b>
            </p>
          </div>
          <div class="col-3">
            <div class="text-center mb-n5">
              <img src="@/assets/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body wizard-content">
        <v-app>
          <v-stepper alt-labels v-model="e1" class="elevation-0">
            <v-stepper-header class="elevation-0">
              <v-stepper-step :complete="e1 > 1" step="1">
                <h6>Servicio</h6>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="e1 > 2" step="2">
                <h6>Tiempo</h6>
              </v-stepper-step>
              <v-divider></v-divider>
              <template v-if="!isIndividual">
                <v-stepper-step :complete="e1 > 3" step="3">
                  <h6>Participantes</h6>
                </v-stepper-step>
                <v-divider></v-divider>
              </template>
              <v-stepper-step :complete="e1 > 4" step="4">
                <h6>Detalle</h6>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5">
                <h6>Hecho</h6>
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <section>
                  <step-service :data="data" v-if="e1 === 1"></step-service>
                </section>
              </v-stepper-content>
              <v-stepper-content step="2">
                <section>
                  <step-time :data="data" v-if="e1 === 2"></step-time>
                </section>
              </v-stepper-content>
              <v-stepper-content step="3">
                <section>
                  <step-participants :data="data" v-if="e1 === 3" @onUpload="(e) => { upload = e }"></step-participants>
                </section>
              </v-stepper-content>
              <v-stepper-content step="4">
                <section>
                  <step-details :data="data" v-if="e1 === 4"></step-details>
                </section>
              </v-stepper-content>
              <v-stepper-content step="5">
                <section>
                  <step-done :data="data" v-if="e1 === 5"></step-done>
                </section>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
          <div class="d-flex align-items-center justify-content-end gap-2">
            <button class="btn btn-outline-primary" :disabled="upload" v-if="e1 > 1" @click="onPrev()">Anterior</button>
            <button class="btn btn-primary" :disabled="upload" v-if="e1 < steps" @click="onNext()">Siguiente</button>
            <button class="btn btn-primary" v-if="e1 === steps" @click="onNext()">Finalizar</button>
          </div>
        </v-app>
      </div>
    </div>
  </div>
</template>
<script>
import StepService from '@/pages/home/steps/Service'
import StepTime from '@/pages/home/steps/Time'
import StepParticipants from '@/pages/home/steps/Participants'
import StepDetails from '@/pages/home/steps/Details'
import StepDone from '@/pages/home/steps/Done'
import profilebg from '@/assets/images/backgrounds/cta-bg.jpg'
export default {
  components: { StepService, StepTime, StepParticipants, StepDetails, StepDone },
  data () {
    return {
      profilebg,
      e1: 1,
      steps: 5,
      next: false,
      data: {
        participants: 0,
        schedule_id: null,
        first_name: '',
        last_name: '',
        date: '',
        appends: []
      },
      count: 0,
      upload: false,
      rating: false
    }
  },
  computed: {
    isIndividual () {
      console.log(this.data.category)
      return this.data.category && this.data.category.is_individual
    }
  },
  methods: {
    onPrev () {
      const prev = this.e1 - 1
      this.e1 = (this.isIndividual && prev === 3) ? 2 : prev
    },
    onNext: function () {
      this.count++
      if (this.count !== 1) {
        return
      }
      this.data.step = this.e1
      this.data.category_id = this.data.category ? this.data.category.id : null
      let form = new FormData()
      this.$.each(this.data, function (key, item) {
        if (item != null) {
          if (key === 'appends') {
            form.append(key, JSON.stringify(item))
          } else {
            form.append(key, item)
          }
        }
      })
      this.$axios({
        url: '/appointments',
        method: 'POST',
        data: form
      })
        .then((resp) => {
          if (this.e1 === 5) {
            this.rating = true
            this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          } else {
            let nextStep = resp.data.step
            if (this.isIndividual && nextStep === 3) {
              nextStep = 4
            }
            this.e1 = nextStep
          }
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    },
    onClear: function () {
      this.e1 = 1
      this.data = {
        participants: 0,
        schedule_id: null,
        first_name: '',
        last_name: '',
        date: '',
        appends: []
      }
      this.rating = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Home.vue